import { ReactNode } from "react";
import { toast } from "react-toastify";
import classnames from "classnames";
import "react-toastify/dist/ReactToastify.min.css";
import styles from "./toast.module.css";

const config = {
  closeButton: false,
  autoClose: 3000,
  position: "bottom-right",
  className: styles.toast,
  progressClassName: styles.progress,
  closeOnClick: true,
};

export default {
  success: (msg: ReactNode) => {
    toast.success(msg, {
      ...config,
      className: classnames(config.className, styles.success),
    });
  },
  info: (msg: ReactNode) => {
    toast.info(msg, {
      ...config,
      className: classnames(config.className, styles.info),
    });
  },
  error: (msg: ReactNode) => {
    toast.error(msg, {
      ...config,
      className: classnames(config.className, styles.error),
    });
  },
};
